import React from 'react'
import SectionHeader from './SectionHeader';
import { StickyNote } from 'lucide-react';
import { renderRichText, richTextClass } from '@univdiam/ui/lib/renderRichText';
import { cn } from '@univdiam/ui/lib/utils';

type SpecialInstructionsProps = {
  specialInstructions: string
}
function SpecialInstructions({ specialInstructions }: SpecialInstructionsProps) {
  // Check if it's genuinely empty or just empty HTML tags from Tiptap
  const hasContent = specialInstructions && specialInstructions.trim() !== '' && specialInstructions !== '<p></p>' && specialInstructions !== '<p><br></p>';

  return (
    <div className='flex flex-col bg-white border border-[#E9EAEB] rounded-md'>
      <SectionHeader title='Special Instructions' sectionIcon={<StickyNote strokeWidth={1.5} className="w-5 h-5 text-gray-600" />} />
      {
        hasContent ? <div className={cn('p-4 gap-4 text-body2 leading-relaxed break-words [&_p]:min-h-[1.25rem]', richTextClass)} dangerouslySetInnerHTML={{ __html: renderRichText(specialInstructions) }}>
        </div> : <p className='flex items-center justify-center my-6 text-gray-500'>No special instructions</p>
      }

    </div>
  )
}

export default SpecialInstructions